import { MdCleaningServices } from 'react-icons/md';
import { FormFilter, BoxSearch, IconSearch, InputSearch, ButtonSearch, ButtonClearSearch, ViewFilter } from './style'
import { FaFilter } from 'react-icons/fa';
import { useEffect, useState } from 'react';

type InpuSearchProps = {
  setFilter?: (value: string) => void;
  searchData?: string;
  isSearch?: boolean;
  handleResetInputSearch?: () => void;
  setSearchData?: (value: string) => void;
  onShowFilters: () => void;
}

const InpuSearch = ({
  searchData,
  isSearch,
  handleResetInputSearch,
  setSearchData,
  onShowFilters
}: InpuSearchProps) => {
  const [localSearch, setLocalSearch] = useState(searchData);

  useEffect(() => {
    setLocalSearch(searchData);
  }, [searchData]);

  const handleSearchClick = () => {
    setSearchData(localSearch);
  };

  const handleClearClick = () => {
    setLocalSearch("");
    setSearchData("");
    if (handleResetInputSearch) {
      handleResetInputSearch();
    }
  };

  return (
    <FormFilter>
      <ViewFilter onClick={() => onShowFilters()}>
        <FaFilter color='#264259' />
        Filtros
      </ViewFilter>
      <BoxSearch>
        <IconSearch size={24} color='#5061768F' />
        <InputSearch
          style={{ width: "100%" }}
          type="text"
          placeholder="Digite sua busca"
          value={localSearch}
          onChange={(event) => setLocalSearch(event.target.value)}
        />
      </BoxSearch>

      {!isSearch ? (
        <ButtonSearch onClick={handleSearchClick}>
          Buscar
        </ButtonSearch>
      ) : (
        <ButtonClearSearch
          className="text-light"
          variant="info"
          onClick={handleClearClick}
        >
          <MdCleaningServices size={15} style={{ marginRight: 4 }} />
          Limpar
        </ButtonClearSearch>
      )}
    </FormFilter >
  )
}

export default InpuSearch